import BaseService from '@/services-ts/BaseService'
import type { ICompanySettings } from '@/types/Data'
import type { IPayloadCompanySetting } from '@/types/Request'

export default class DepartmentServices extends BaseService {
  GetDepartmentList() {
    return this.GET<ICompanySettings[]>(this.PATHS.GET_DEPARTMENT_LIST)
  }

  CreateDepartment(Name: string) {
    return this.POST<ICompanySettings>(this.PATHS.CREATE_DEPARTMENT, { Name })
  }

  UpdateDepartment(payload: IPayloadCompanySetting) {
    return this.POST<ICompanySettings>(this.PATHS.UPDATE_DEPARTMENT, payload)
  }

  DeleteDepartment(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_DEPARTMENT, { Id })
  }
}
